import React from "react";

type Props = {
  width?: number;
  height?: number;
  className?: string;
  variant?: 'default' | 'light';
};

export const AuliLogo: React.FC<Props> = ({ width = 70, height = 32, className, variant = 'default' }) => {
  const navyFill = variant === 'light' ? 'white' : '#008';
  
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2125 980.64"
    role="img"
    aria-label="Auli"
    preserveAspectRatio="xMidYMid meet"
    style={{ width: `${width}px`, height: `${height}px`, display: "block", transition: "none" }}
    className={className}
  >
    <path fill={navyFill} d="M797.89,704.49v-321.85c0-14.83,12.03-26.86,26.86-26.86h80.65c14.83,0,26.86,12.03,26.86,26.86v282.72c0,66.94,43.25,110.2,108.14,110.2,69,0,115.35-44.29,115.35-112.26v-280.66c0-14.83,12.03-26.86,26.86-26.86h80.48c14.83,0,26.86,12.03,26.86,26.86v483.46c0,14.83-12.03,26.86-26.86,26.86h-80.48c-14.83,0-26.86-12.03-26.86-26.86v-48.96c-22.54,64.58-94.75,88.18-159.63,88.18-118.43,0-198.22-79.3-198.22-200.82Z"/>
    <path fill={navyFill} d="M706.9,762.54c-23.07.43-42.4-17.14-42.4-40.22v-339.68c0-14.83-12.03-26.86-26.86-26.86h-80.58c-14.83,0-26.86,12.03-26.86,26.86v46.89c-42.24-46.36-100.97-74.18-170.96-74.18-146.23,0-256.47,118.48-256.47,275.01s110.24,274.94,256.47,274.94c76.17,0,140.05-34,182.29-88.53,26.73,94.77,165.87,76.17,165.87,76.17,12.88,0,23.33-10.45,23.33-23.33v-83.75c0-11.83-9.07-23.6-23.83-23.32ZM385.68,774.25c-82.91,0-149.45-69.9-144.06-153.89,4.62-71.87,63.22-130.24,135.11-134.57,83.82-5.05,153.32,61.38,153.32,144.1s-64.61,144.37-144.37,144.37Z"/>
    <path fill={navyFill} d="M1417.6,87.2h80.58c14.83,0,26.86,12.03,26.86,26.86v752.05c0,14.83-12.03,26.86-26.86,26.86h-80.58c-14.83,0-26.86-12.03-26.86-26.86V114.05c0-14.83,12.03-26.86,26.86-26.86Z"/>
    <path fill={navyFill} d="M1652.42,355.78h80.58c14.83,0,26.86,12.03,26.86,26.86v483.46c0,14.83-12.03,26.86-26.86,26.86h-80.58c-14.83,0-26.86-12.03-26.86-26.86v-483.46c0-14.83,12.03-26.86,26.86-26.86Z"/>
    <path fill="#73d8b2" d="M1692.71,256.62c-50.82,0-90.65-42.58-90.65-92.02s42.57-89.27,92.01-89.27,89.28,42.58,89.28,92.02-42.59,89.27-90.65,89.27Z"/>
    <path fill="#73d8b2" d="M1928.29,904.85c-50.82,0-90.65-42.58-90.65-92.02s42.57-89.27,92.01-89.27,89.28,42.58,89.28,92.02-42.59,89.27-90.65,89.27Z"/>
  </svg>
  );
};
